import { CFIconArrowCircleDown } from './arrow-circle-down';
import { CFIconArrowCircleLeft } from './arrow-circle-left';
import { CFIconArrowCircleRight } from './arrow-circle-right';
import { CFIconArrowCircleUp } from './arrow-circle-up';
import { CFIconArrowCornerDownLeft } from './arrow-corner-down-left';
import { CFIconArrowCornerDownRight } from './arrow-corner-down-right';
import { CFIconArrowCornerLeftDown } from './arrow-corner-left-down';
import { CFIconArrowCornerLeftUp } from './arrow-corner-left-up';
import { CFIconArrowCornerRightDown } from './arrow-corner-right-down';
import { CFIconArrowCornerRightUp } from './arrow-corner-right-up';
import { CFIconArrowCornerUpLeft } from './arrow-corner-up-left';
import { CFIconArrowCornerUpRight } from './arrow-corner-up-right';
import { CFIconArrowDiagonalLeftDown } from './arrow-diagonal-left-down';
import { CFIconArrowDiagonalLeftUp } from './arrow-diagonal-left-up';
import { CFIconArrowDiagonalRightDown } from './arrow-diagonal-right-down';
import { CFIconArrowDiagonalRightUp } from './arrow-diagonal-right-up';
import { CFIconArrowDown } from './arrow-down';
import { CFIconArrowLeft } from './arrow-left';
import { CFIconArrowRight } from './arrow-right';
import { CFIconArrowUp } from './arrow-up';
import { CFIconCaretDown } from './caret-down';
import { CFIconCaretLeft } from './caret-left';
import { CFIconCaretRight } from './caret-right';
import { CFIconCaretUp } from './caret-up';
import { CFIconChevronDown } from './chevron-down';
import { CFIconChevronLeft } from './chevron-left';
import { CFIconChevronRight } from './chevron-right';
import { CFIconChevronsDown } from './chevrons-down';
import { CFIconChevronsLeft } from './chevrons-left';
import { CFIconChevronSmallDown } from './chevron-small-down';
import { CFIconChevronSmallLeft } from './chevron-small-left';
import { CFIconChevronSmallRight } from './chevron-small-right';
import { CFIconChevronSmallUp } from './chevron-small-up';
import { CFIconChevronsRight } from './chevrons-right';
import { CFIconChevronsUp } from './chevrons-up';
import { CFIconChevronUp } from './chevron-up';
import { CFIconSwap } from './swap';
export const CFIconGroupArrows = [
    CFIconArrowCircleDown,
    CFIconArrowCircleLeft,
    CFIconArrowCircleRight,
    CFIconArrowCircleUp,
    CFIconArrowCornerDownLeft,
    CFIconArrowCornerDownRight,
    CFIconArrowCornerLeftDown,
    CFIconArrowCornerLeftUp,
    CFIconArrowCornerRightDown,
    CFIconArrowCornerRightUp,
    CFIconArrowCornerUpLeft,
    CFIconArrowCornerUpRight,
    CFIconArrowDiagonalLeftDown,
    CFIconArrowDiagonalLeftUp,
    CFIconArrowDiagonalRightDown,
    CFIconArrowDiagonalRightUp,
    CFIconArrowDown,
    CFIconArrowLeft,
    CFIconArrowRight,
    CFIconArrowUp,
    CFIconCaretDown,
    CFIconCaretLeft,
    CFIconCaretRight,
    CFIconCaretUp,
    CFIconChevronDown,
    CFIconChevronLeft,
    CFIconChevronRight,
    CFIconChevronsDown,
    CFIconChevronsLeft,
    CFIconChevronSmallDown,
    CFIconChevronSmallLeft,
    CFIconChevronSmallRight,
    CFIconChevronSmallUp,
    CFIconChevronsRight,
    CFIconChevronsUp,
    CFIconChevronUp,
    CFIconSwap,
];
